import api from './client';

export interface WhiteLabelConfig {
  id: string;
  organization_id: string;
  app_name: string;
  company_name: string | null;
  logo_url: string | null;
  favicon_url: string | null;
  primary_color: string;
  secondary_color: string;
  accent_color: string;
  welcome_message: string | null;
  footer_text: string | null;
  support_email: string | null;
  support_url: string | null;
  hide_geniac_branding: boolean;
  custom_domain: string | null;
  is_active: boolean;
  created_at: string;
  updated_at: string;
  created_by: string;
}

export interface ConfigureWhiteLabelRequest {
  app_name?: string;
  company_name?: string;
  logo_url?: string;
  favicon_url?: string;
  primary_color?: string;
  secondary_color?: string;
  accent_color?: string;
  welcome_message?: string;
  footer_text?: string;
  support_email?: string;
  support_url?: string;
  hide_geniac_branding?: boolean;
  custom_domain?: string;
}

/**
 * Get White Label configuration
 */
export async function getWhiteLabelConfig(): Promise<{ success: boolean; config: WhiteLabelConfig | null; has_config: boolean }> {
  const response = await api.get('/api/white-label/config');
  return response.data;
}

/**
 * Configure or update White Label
 */
export async function configureWhiteLabel(config: ConfigureWhiteLabelRequest): Promise<{
  success: boolean;
  message: string;
  config: WhiteLabelConfig;
}> {
  const response = await api.post('/api/white-label/configure', config);
  return response.data;
}

/**
 * Reset White Label to defaults
 */
export async function resetWhiteLabel(): Promise<{ success: boolean; message: string; config: WhiteLabelConfig }> {
  const response = await api.post('/api/white-label/reset');
  return response.data;
}

/**
 * Delete White Label configuration
 */
export async function deleteWhiteLabelConfig(): Promise<{ success: boolean; message: string }> {
  const response = await api.delete('/api/white-label/config');
  return response.data;
}
